<template>

  <l-table
    ref="studentTable"
    :module-name="MODULE_NAME"
    :table-columns="tableColumns"
    :filter-class="filterClass"
  >
    <template #before-search>
      <download-file
        class="mr-1"
        :payload="{scholarship_status: $route.meta.scholarship}"
        dispatch-action="staticModule/otmItmApplyDocsExel"
      />
    </template>
    <template #create-body>
      <update
        @refetchData="refetch"
      />
      <change-state @refetchData="refetch" />
      <create-confirmed-scientific-topic @refetchData="refetch" />
    </template>

    <template #cell(dc_type)="{ data }">
      {{ $langName(getDcType(data.value).name) }}
    </template>

    <template #cell(state)="{ data }">
      {{ getStateName(data.value) }}

    </template>

    <template #cell(user)="{ data }">
      {{ data.value.full_name }}
    </template>

    <template #cell(edu_lang)="{ data }">
      {{ $langName(getEduLang(data.value).name) }}
    </template>

    <template #cell(advisor)="{ data }">
      {{ data.value ? data.value.full_name : '' }}
    </template>

    <template #cell(quarter)="{ data }">
      {{ data.value.period.admission_year + '/' +data.value.quarter }}
    </template>

    <template #cell(organization)="{ data }">
      {{ $langName(data.value.name) }}
    </template>

    <template #cell(direction)="{ data }">
      <p :title="$langName(data.value.name)">
        {{ data.value.code }}
      </p>
      <p
        v-if="data.item.direction_second"
        :title="$langName(data.item.direction_second.name)"
      >
        {{ data.item.direction_second.code }}
      </p>
    </template>

    <template #cell(mob_phone_no)="{ data }">
      {{ data.value.mob_phone_no }}
    </template>

    <template #cell(status)="{ data }">
      <b-badge :variant="getApplyDocumentStatusColor(data.value)">
        {{ $langName(getApplyDocumentStatus(data.value).name) }}
      </b-badge>
    </template>

    <!-- Column: Actions -->
    <template #cell(actions)="{ data }">

      <div class="text-nowrap">
        <feather-icon
          icon="EyeIcon"
          class="cursor-pointer mr-1"
          size="16"
          @click="$router.push({ name: 'applicant-document-view', params: { id: data.item.id }})"
        />
        <feather-icon
          v-if="canUpdate(data.item)"
          v-b-toggle.sidebar-update-student
          icon="EditIcon"
          class="cursor-pointer mr-1"
          size="16"
          @click="update(data.item)"
        />
        <feather-icon
          v-if="canChangeState(data.item)"
          v-b-toggle.sidebar-change-state
          icon="Edit3Icon"
          class="cursor-pointer mr-1"
          size="16"
          title="Himoya holatini o'zgartirish"
          @click="updateState(data.item)"
        />
        <feather-icon
          v-if="$can('manage', 'ScientificTopicProtocol')"
          v-b-toggle.sidebar-create-confirmed-scientific-topic
          icon="FilePlusIcon"
          class="cursor-pointer mr-1"
          size="16"
          :title="$t('Create scientific topic')"
          @click="createScientificTopic(data.item)"
        />
      </div>
    </template>
  </l-table>
</template>

<script>
import {
  VBToggle, BBadge,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import config from './config'
import studentModule from '@/store/student/index'
import permission from './permission'
import Update from './Update.vue'
import StudentList from '@/views/components/filters/service/StudentList'
import LTable from '@/views/components/LTable.vue'
import periodModule from '@/store/period'
import { myOrganization } from '@/auth/utils'
import DownloadFile from '@/views/pages/all-exams/components/Excel.vue'
import ChangeState from '@/views/pages/student-list/ChangeState.vue'
import { DissertationStatusList } from '@/classes/DissertationStatuses'
import CreateConfirmedScientificTopic from '@/views/pages/confirmed-scientific-topic/Create.vue'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    ChangeState,
    DownloadFile,
    Update,
    CreateConfirmedScientificTopic,
    LTable,
    BBadge,
  },
  created() {
    this.$store.commit(`${this.MODULE_NAME}/FRESH`)
    this.$store.dispatch('period/list', { limit: 9999, ordering: '-admission_year' })
    this.$store.dispatch('staticModule/quarters')
    if (myOrganization()) {
      this.$store.dispatch('staticModule/directionList', { org_id: myOrganization().id })
    }
  },
  mounted() {
    this.$refs.studentTable.extraParams = { is_otm: true, scholarship_status: this.$route.meta.scholarship }
  },
  methods: {
    getDcType(id) {
      return this.$store.getters['staticModule/getDcType'](id)
    },
    getEduLang(id) {
      return this.$store.getters['staticModule/getEduLangType'](id)
    },
    getApplyDocumentStatus(id) {
      return this.$store.getters['staticModule/getApplyDocumentStatus'](id)
    },
    getApplyDocumentStatusColor(id) {
      return this.$store.getters['staticModule/getApplyDocumentStatusColor'](id)
    },
    update(data) {
      this.$store.commit(`${this.MODULE_NAME}/UPDATE_COURSE`, data)
    },
    updateState(data) {
      this.$store.commit(`${this.MODULE_NAME}/UPDATE_COURSE`, data)
    },
    createScientificTopic(data) {
      const name = data.scientific_work_name || ''
      this.$store.commit('confirmedScientificTopic/UPDATE', {
        id: null,
        name_uz: name,
        name_ru: name,
        name_en: name,
        apply_doc: data.id,
        apply_doc_name: data.user?.full_name || '',
        scientific_topic_protocol: null,
      })
    },
    refetch() {
      this.$refs.studentTable.refetchData()
    },
    getStateName(state) {
      const findState = DissertationStatusList.find(item => item.id === state)
      return findState ? this.$langName(findState) : '-'
    },
  },
  setup() {
    const filterClass = new StudentList()
    const MODULE_NAME = 'student'
    const MODULE_PERIOD = 'period'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, studentModule)
    if (!store.hasModule(MODULE_PERIOD)) store.registerModule(MODULE_PERIOD, periodModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
      if (store.hasModule(MODULE_PERIOD)) store.unregisterModule(MODULE_PERIOD)
    })

    return {
      filterClass,
      ...config(),
      MODULE_NAME,
      ...permission(),
    }
  },
}
</script>

<style lang="scss">
.student-list-actions-column {
  position: sticky;
  right: 0;
  z-index: 2;
  background: #fff;
  box-shadow: -6px 0 8px -8px rgba(34, 41, 47, 0.35);
}

thead .student-list-actions-column {
  z-index: 3;
}
</style>
